export default __webpack_public_path__ + "static/media/fox.53d5e082.png";